import angular from "angular";
import dcStudentNav from "./student-nav.directive";
import StudentSidebarNavigationController from "./student-nav.controller";
export default angular
  .module("student.directives.nav", [])
  .directive("dcStudentNav", dcStudentNav)
  .controller(
    "StudentSidebarNavigationController",
    StudentSidebarNavigationController,
  );
